










import { LogStatus } from "@/constant";
import "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Error extends Vue {
  @Prop() code: string | undefined;
  @Prop() networkError: string | undefined;

  get status() {
    return (LogStatus as Record<string, string>)[this.code || ""];
  }
}
